const isSP = () => {
  return $(window).innerWidth() <= 840
}

const isPC = () => {
  return $(window).innerWidth() >= 841
}

const deviceType = () => {
  const ua = navigator.userAgent
  if (ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || (ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0)) {
    return 'sp'
  } else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
    return 'tablet'
  } else {
    return 'pc'
  }
}

const isAndroid = () => {
  const ua = navigator.userAgent
  return ua.indexOf('Android') > 0
}

const EnvUtil = {
  isSP: isSP,
  isPC: isPC,
  deviceType: deviceType,
  isAndroid: isAndroid
}
export default EnvUtil